import { render, staticRenderFns } from "./leave_table.vue?vue&type=template&id=22bf3cc0&scoped=true"
import script from "./leave_table.vue?vue&type=script&lang=js"
export * from "./leave_table.vue?vue&type=script&lang=js"
import style0 from "./leave_table.vue?vue&type=style&index=0&id=22bf3cc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bf3cc0",
  null
  
)

export default component.exports